<template lang="pug">
    multiselect(
        :value="value"
        :options="timezones"
        label="zone"
        track-by="zone"
        name="timezone"
        @input="onInput"
        :disabled="disabled"
    )
        template(slot="option" slot-scope="props")
            span.block {{ props.option.zone }} ({{ props.option.offset }})
</template>

<script>
import timezone from '@js/store/modules/timezone';
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters('timezone', ['timezones']),
    },

    beforeCreate() {
        if (!this.$store.hasModule('timezone')) {
            this.$store.registerModule('timezone', timezone);
        }
    },

    mounted() {
        this.getTimezones();
    },

    methods: {
        ...mapActions('timezone', ['getTimezones']),

        onInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>
